<template>
    <custom-dialog width="864px" :showClose="true" v-if="visibleObj.refundItemDialog"
        :visible="visibleObj.refundItemDialog">
        <div slot="header" class="dialog-title">
            <div>选择退费项目</div>
            <div @click="dialogVisible('refundItemDialog')"><i class="el-icon-close close-icon"></i></div>
        </div>
        <div class="refundItemContent" slot="content" v-loading="loading">
            <div class="content_tips"><i class="el-icon-edit el-icon-warning color1890 mr3"></i>订单使用优惠券后，全额退款时将退还优惠券；部分退款时不退还优惠券。</div>
            <!-- 医保项目 -->
            <div v-if="ybProjectList.length > 0" class="mb22">
                <el-checkbox @change="changeYbChecked" v-model="ybChecked" class="fwb color1F23">医保支付项目 <span class="size11">提示：医保支付项目仅支持整单退费，已执行的理疗项目也会将全部退费</span></el-checkbox>
                <div v-for="(item, index) in ybProjectList" :key="index">
                    <!-- <div v-if="item.projectType == '1'" class="mb22"> -->
                    <div class="table" v-if="item.projectType == '1'">
                        <div class="table-header">
                            <el-checkbox disabled v-model="item.checked"
                                class="fwb w32 flex-sh tac color1F23"></el-checkbox>
                            <div class="flex1 display-f align-i-c">
                                <div class="ml8 color1F23 fwb">中药处方</div>
                                <div v-if="item.isYlcp && item.isYlcp == '1'" class="ml8 color1F23 fwb">医联产品
                                    {{ item.orderName }}</div>
                            </div>
                            <div class="w86 flex-sh tac">可退数量</div>
                            <div class="w38 flex-sh tac">单位</div>
                            <div class="w124 flex-sh tac">金额</div>
                        </div>
                        <div class="table-row" v-for="obj in item.item" :key="obj.detailId">
                            <div class="checkbox-warp">
                                <el-checkbox disabled v-model="item.checked"></el-checkbox>
                            </div>
                            <div class="row-content">
                                <span class="color1F23">{{item.isYlcp == '1' ?'医联明细': obj.itemName }}</span>
                            </div>
                            <div class="number-warp disabled" v-if="jgList.includes(obj.itemName) && obj.projectType != '4' ">-</div>
                            <div class="number-warp disabled" v-else>{{ item.quantity }}剂*{{ obj.num }}</div>
                            <div class="unit-warp">{{ obj.unit }}</div>
                            <div class="price-warp">{{ obj.totalPrice }}</div>
                        </div>
                    </div>
                     <div class="table" v-if="item.projectType == '15'">
                        <div class="table-header">
                            <el-checkbox disabled v-model="item.checked"
                                class="fwb w32 flex-sh tac color1F23"></el-checkbox>
                            <div class="flex1 display-f align-i-c">
                                <div class="ml8 color1F23 fwb">中成药处方</div>
                            </div>
                            <div class="w86 flex-sh tac">可退数量</div>
                            <div class="w38 flex-sh tac">单位</div>
                            <div class="w124 flex-sh tac">金额</div>
                        </div>
                        <div class="table-row" v-for="obj in item.item" :key="obj.detailId">
                            <div class="checkbox-warp">
                                <el-checkbox disabled v-model="item.checked"></el-checkbox>
                            </div>
                            <div class="row-content">
                                <span class="color1F23">{{ obj.itemName }}</span>
                            </div>
                            <div class="number-warp disabled">{{ obj.num }}</div>
                            <div class="unit-warp">{{ obj.unit }}</div>
                            <div class="price-warp">{{ obj.totalPrice }}</div>
                        </div>
                    </div>
                    <div class="table" v-if="item.projectType == '2'">
                        <div class="table-header">
                            <el-checkbox disabled v-model="item.checked"
                                class="fwb w32 flex-sh tac color1F23"></el-checkbox>
                            <div class="flex1">
                                <span class="ml8 color1F23 fwb">理疗处方</span>
                            </div>
                            <div class="w86 flex-sh tac">可退数量</div>
                            <div class="w38 flex-sh tac">单位</div>
                            <div class="w124 flex-sh tac">金额</div>
                        </div>
                        <div class="table-row" v-for="obj in item.item" :key="obj.detailId">
                            <div class="checkbox-warp">
                                <el-checkbox disabled v-model="obj.checked"></el-checkbox>
                            </div>
                            <div class="row-content">
                                <div class="color1F23">{{ obj.itemName }}</div>
                                <div class="colorF54A" v-if="obj.useNum">已执行{{ computedPhy( obj.useNum,obj.onlyNum) }}次</div>
                            </div>
                            <div class="number-warp disabled">{{ computedPhy(obj.num,obj.onlyNum) }}</div>
                            <div class="unit-warp">次</div>
                            <div class="price-warp">{{ obj.totalPrice }}</div>
                        </div>
                    </div>
                    <div class="table" v-if="item.projectType == '4'">
                        <div class="table-header">
                            <el-checkbox disabled v-model="item.checked"
                                class="fwb w32 flex-sh tac color1F23"></el-checkbox>
                            <div class="flex1">
                                <span class="ml8 color1F23 fwb">其他收费项目</span>
                            </div>
                            <div class="w86 flex-sh tac">可退数量</div>
                            <div class="w38 flex-sh tac">单位</div>
                            <div class="w124 flex-sh tac">金额</div>
                        </div>
                        <div class="table-row" v-for="obj in item.item" :key="obj.detailId">
                            <div class="checkbox-warp">
                                <el-checkbox disabled v-model="obj.checked" :true-label="1"
                                    :false-label="0"></el-checkbox>
                            </div>
                            <div class="row-content">
                                <span class="color1F23">{{ obj.itemName }}</span>
                            </div>
                            <div class="number-warp disabled">{{ obj.residueNum  }}</div>
                            <div class="unit-warp">{{ obj.unit }}</div>
                            <div class="price-warp">{{ obj.totalPrice }}</div>
                        </div>
                    </div>
                    <!-- </div> -->
                </div>
            </div>
            <div v-if="projectList.length > 0">
                <el-checkbox @change="changeNotYbChecked" v-model="notYbChecked" class="fwb color1F23">非医保支付项目</el-checkbox>
                <div v-for="(item, index) in projectList" :key="index">
                    <div v-if="item.isMedical == '0'">
                        <div class="table" v-if="item.projectType == '1'">
                            <div class="table-header">
                                <el-checkbox @change="projectItemChange($event, item)" v-model="item.checked" class="fwb w32 flex-sh tac color1F23"></el-checkbox>
                                <div class="flex1 display-f align-i-c">
                                    <div class="ml8 color1F23 fwb">中药处方</div>
                                    <div class="ml20" v-if="item.checked && doseNumberDisabled(item)">
                                        共{{ item.doseNum }}剂，退
                                        <el-input-number class="w100 ml8" @change="doseNumChange($event, $event, item)" size="mini" :min="1" :max="item.doseNum" v-model="item.quantity"></el-input-number>
                                    </div>
                                    <div v-if="item.isYlcp && item.isYlcp == '1'" class="ml8 color1F23 fwb">医联产品 {{ item.projectName }}</div>
                                </div>
                                <div class="w86 flex-sh tac">可退数量</div>
                                <div class="w38 flex-sh tac">单位</div>
                                <div class="w124 flex-sh tac">金额</div>
                            </div>
                            <div class="table-row" v-for="obj in item.item" :key="obj.detailId">
                                <div class="checkbox-warp">
                                    <!-- ==={{ obj.checked }} -->
                                    <el-checkbox @change="itemChange($event, item)" v-model="obj.checked"
                                        :disabled="item.isYlcp && item.isYlcp == '1'"></el-checkbox>
                                </div>
                                <div class="row-content">
                                    <span class="color1F23">{{ item.isYlcp == '1' ? '医联明细' : obj.itemName }}</span>
                                </div>
                                <!-- <div class="number-warp disabled" v-if="obj.itemName == '加工'">-</div> -->
                                <div class="number-warp disabled"
                                    v-if="jgList.includes(obj.itemName) && obj.projectType != '4' ">-</div>
                                <div class="number-warp disabled" v-else>{{ item.quantity }}剂*{{ obj.num }}</div>
                                <div class="unit-warp">{{ obj.unit }}</div>
                                <div class="price-warp">{{ obj.totalPrice }}</div>
                            </div>
                        </div>
                        <div class="table" v-if="item.projectType == '15'">
                            <div class="table-header">
                                <el-checkbox v-model="item.checked" @change="projectItemChange($event, item)" class="fwb w32 flex-sh tac color1F23"></el-checkbox>
                                <div class="flex1 display-f align-i-c">
                                    <div class="ml8 color1F23 fwb">中成药处方</div>
                                </div>
                                <div class="w86 flex-sh tac">可退数量</div>
                                <div class="w38 flex-sh tac">单位</div>
                                <div class="w124 flex-sh tac">金额</div>
                            </div>
                            <div class="table-row" v-for="obj in item.item" :key="obj.detailId">
                                <div class="checkbox-warp">
                                    <el-checkbox @change="itemChange($event, item)" v-model="obj.checked"></el-checkbox>
                                </div>
                                <div class="row-content">
                                    <span class="color1F23">{{ obj.itemName }}</span>
                                </div>
                                <div class="number-warp disabled">{{ obj.num }}</div>
                                <div class="unit-warp">{{ obj.unit }}</div>
                                <div class="price-warp">{{ obj.totalPrice }}</div>
                            </div>
                            </div>
                        </div>
                        <div class="table" v-if="item.projectType == '2'">
                            <div class="table-header">
                                <el-checkbox @change="projectItemChange($event, item)" v-model="item.checked"
                                    class="fwb w32 flex-sh tac color1F23"></el-checkbox>
                                <div class="flex1">
                                    <span class="ml8 color1F23 fwb">理疗处方</span>
                                </div>
                                <div class="w86 flex-sh tac">可退数量</div>
                                <div class="w38 flex-sh tac">单位</div>
                                <div class="w124 flex-sh tac">金额</div>
                            </div>
                            <div class="table-row" v-for="obj in item.item" :key="obj.detailId">
                                <div class="checkbox-warp">
                                    <el-checkbox @change="itemChange($event, item)" v-model="obj.checked"></el-checkbox>
                                </div>
                                <div class="row-content">
                                    <div class="color1F23">{{ obj.itemName }}</div>
                                    <div class="phy_executed" v-if="obj.useNum">已执行{{ computedPhy( obj.useNum,obj.onlyNum) }}次<span class="phy_executed_copy" @click="copyExecuteId(obj.physioExecuteId)">复制执行ID</span></div>
                                </div>
                                <div class="number-warp">
                                    <el-input-number size="big" :max="computedPhy(obj.residueNum,obj.onlyNum)" :min="0" :precision="0"
                                        v-model.trim="obj.quantity"></el-input-number>
                                </div>
                                <div class="unit-warp">次</div>
                                <div class="price-warp">{{ obj.totalPrice }}</div>
                            </div>
                        </div>
                        <div class="table" v-if="item.projectType == '30'">
                            <div class="table-header">
                                <el-checkbox @change="projectItemChange($event, item)" v-model="item.checked" :disabled="!item.canChecked" class="fwb w32 flex-sh tac color1F23"></el-checkbox>
                                <div class="flex1 activity-title">
                                    <span class="ml8 color1F23 fwb">{{ item.actName }}</span>
                                    <span class="activity-count">共{{ item.actCount }}套</span>
                                    <div v-if="item.hasUsed" class="activity-tips">
                                        <span class="el-icon-warning-outline activity-tips-icon"></span>
                                        <span class="activity-tips-text">存在已执行的理疗项目，不支持退款</span>
                                    </div>
                                </div>
                                <div class="w86 flex-sh tac">可退数量</div>
                                <div class="w38 flex-sh tac">单位</div>
                                <div class="w124 flex-sh tac">金额</div>
                            </div>
                            <div class="table-row" v-for="obj in item.item" :key="obj.detailId">
                                <div class="checkbox-warp">
                                    <el-checkbox v-model="obj.checked" disabled></el-checkbox>
                                </div>
                                <div class="row-content">
                                    <div class="color1F23">{{ obj.itemName }}</div>
                                    <div class="phy_executed" v-if="obj.useNum">已执行{{ computedPhy( obj.useNum,obj.onlyNum) }}次<span class="phy_executed_copy" @click="copyExecuteId(obj.physioExecuteId)">复制执行ID</span></div>
                                </div>
                                <div class="number-warp">
                                    <div>{{ obj.quantity }}</div>
                                </div>
                                <div class="unit-warp">{{ obj.unit }}</div>
                                <div class="price-warp">{{ obj.amount }}</div>
                            </div>
                        </div>
                        <div class="table" v-if="item.projectType == '4'">
                            <div class="table-header">
                                <el-checkbox @change="projectItemChange($event, item)" v-model="item.checked"
                                    class="fwb w32 flex-sh tac color1F23"></el-checkbox>
                                <div class="flex1">
                                    <span class="ml8 color1F23 fwb">其他收费项目</span>
                                </div>
                                <div class="w86 flex-sh tac">可退数量</div>
                                <div class="w38 flex-sh tac">单位</div>
                                <div class="w124 flex-sh tac">金额</div>
                            </div>
                            <div class="table-row" v-for="obj in item.item" :key="obj.detailId">
                                <div class="checkbox-warp">
                                    <el-checkbox @change="itemChange($event, item)" v-model="obj.checked"></el-checkbox>
                                </div>
                                <div class="row-content">
                                    <span class="color1F23">{{ obj.itemName }}<span v-if="obj.commodityType === 1">（赠品）</span></span>
                                </div>
                                <div class="number-warp">
                                    <el-input-number size="big" :max="obj.residueNum" :min="0" :precision='0' v-if="obj.artNo =='1200139'"
                                        v-model.trim="obj.quantity"></el-input-number>
                                    <el-input-number size="big" :max="obj.residueNum" :min="0" v-else
                                        v-model.trim="obj.quantity"></el-input-number>
                                </div>
                                <div class="unit-warp">{{ obj.unit }}</div>
                                <div class="price-warp">{{ obj.totalPrice }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tac" v-if="projectList.length == 0 && ybProjectList.length == 0">暂无可退项目</div>
        </div>
        <div class="footer" slot="footer">
            <el-checkbox @change="handelAllChecked" v-model="allChecked" class="color1F23">全选</el-checkbox>
            <div class="display-f align-i-c">
                <div class="mr16">本次退款金额合计：<span class="color1F23 fwb">￥{{ refundTotal }}</span></div>
                <custom-button type="info" size="medium" @click="dialogVisible('refundItemDialog')">取消</custom-button>
                <custom-button type="primary" size="medium" @click="comfirm">确定</custom-button>
            </div>
        </div>
    </custom-dialog>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import CustomInput from '@/components/CustomInput'
import { payDTO, formulaDTO } from '@/DTO/index'
import { isNull, isEmptyArray, deepClone, isNullObj,mergeSimilarItems } from '@/utils/validateBase'
import { Utils } from '@/utils/utils'
export default {
    // 定义引入的组件
    components: { CustomDialog, CustomInput },
    props: {
        visibleObj: {
            type: Object,
            default: () => { return {} }
        },
        dialogObj: {
            type: Object,
            default: () => { return {} }
        },
    },
    data() {
        return {
            loading: false,//加载
            ybChecked: false,//医保支付项目
            notYbChecked: false,//非医保支付项目
            orderId: '',//就诊id
            refundTotal: 0,//退款总金额
            ybProjectList: [],//医保退费项目
            projectList: [],//非医保退费项目
            allChecked: false,
            jgList: ['煎药费', '打粉', '制丸', '制膏','加工'],
            originalData: []//原始明细数据
        }
    },
    //变量监听
    watch: {
        projectList: {
            deep: true,
            handler(val) {
                this.computedTotal()
                this.judeStatus()
            },
        },
        ybProjectList: {
            deep: true,
            handler() {
                this.computedTotal()
                this.judeStatus()
            },
        }

    },
    // 页面初始化
    created() {
        // CommonDTO.getJGList().then(res => {
        //     let jgList=[]
        //     res.forEach(item=>{ jgList.push(item.artNo) })
        //     this.jgList = jgList
        // })
        let { orderId } = this.dialogObj
        this.orderId = orderId
        this.getRefunditem()
    },
    computed: {
        computedAllChecked() {
            if (Utils.eq(this.ybProjectList.length, 0)) {
                return this.notYbChecked
            } else if (Utils.eq(this.projectList.length, 0)) {
                return this.ybChecked
            } else {
                return this.ybChecked && this.notYbChecked ? true : false
            }
        },
        doseNumberDisabled() {
            return function (item) {
                let listObj = this.originalData.find(obj => { return obj.isMedical != '1' && item.ctOrderId == obj.ctOrderId }) //筛选出当前处方数据
                let flag = listObj.item.length == item.item.length && !(item.item.length==1  && this.jgList.includes(item.item[0].itemName) && item.projectType != '4') //判断当前药品数量是否等于原始数据药品数量
                return flag
            }
        },
        computedPhy(){
          let that = this
          return function(a,b){
            return Number(that.$bigNumber(a,'/',isNull(b)? 1 : b))
          }
        }
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 确定
         */
        async comfirm() {
            let isRefund = await this.judgeIsRefund()
            if(isRefund){
                this.$confirm('存在配方单已开始配方，退费后可能会产生损失，请及时报损', '提示', {
                confirmButtonText: '继续退费',
                cancelButtonText: '取消退费',
                type: 'warning'
                }).then(() => {
                    this.handleRequest()
                }).catch(() => {

                });
            }else{
                this.handleRequest()
            }
        },
        //处理退款数据
        handleRequest(){
            let refundList = []
            if (this.ybChecked && !isEmptyArray(this.ybProjectList)) {
                this.ybProjectList.forEach(item => {
                    let taskItem =[]
                    item.item.forEach(obj => {
                        taskItem.push({
                            ctOrderNumber: obj.ctOrderNumber,
                            spuId: obj.spuId,
                            artNo:obj.artNo,
                            detailId: obj.detailId,
                            quantity: Number(this.jgList.includes(obj.itemName) && item.projectType != '4' ? obj.allNum : obj.quantity)
                        })
                    })
                    refundList.push({
                        orderPaymentRecipeId:item.projectType=='4'?this.orderId:item.orderPaymentRecipeId,
                        taskItem
                    })
                })
            }
            if (!isEmptyArray(this.projectList)) {
                this.projectList.forEach(item => {
                    if (item.projectType == '30') {
                        if (!isNull(item.item)) {
                            let taskItem =[]
                            item.item.forEach(obj => {
                                if (obj.checked) {
                                    taskItem.push({
                                        actNumber: item.actNumber,
                                        ctOrderNumber: obj.ctOrderNumber,
                                        spuId: obj.spuId,
                                        artNo:obj.artNo,
                                        detailId: obj.detailId,
                                        quantity: Number(obj.allNum)
                                    })
                                }
                            
                            })
                            refundList.push({
                                orderPaymentRecipeId: this.orderId,
                                taskItem
                            })
                        } 
                    } else {
                        if (!isNull(item.item)) {
                            let taskItem =[]
                            item.item.forEach(obj => {
                                if (obj.checked) {
                                    taskItem.push({
                                        ctOrderNumber: obj.ctOrderNumber,
                                        spuId: obj.spuId,
                                        artNo:obj.artNo,
                                        detailId: obj.detailId,
                                        commodityType: obj.commodityType || null,
                                        quantity: Number(item.projectType == '1' ? (this.jgList.includes(obj.itemName) && item.projectType != '4' ? obj.allNum : this.$bigNumber(item.quantity, '*', obj.num)) :  this.$bigNumber(obj.quantity,'*',isNull(obj.onlyNum) ? 1 : obj.onlyNum) )
                                    })
                                }
                            
                            })
                            refundList.push({
                                orderPaymentRecipeId:item.projectType=='4'?this.orderId:item.orderPaymentRecipeId,
                                taskItem
                            })
                        }
                    }
                })
            }
            if (isEmptyArray(refundList)) return this.$message.error('请选择退费项目')
            let obj = {
                refundTotal: this.refundTotal,
                record: this.record,
                isHasYB: this.ybChecked && !isEmptyArray(this.ybProjectList),
                refundList,
            }
            if (Utils.eq(this.refundTotal, 0)) {
                this.zeroRefund(obj)
            
            } else {
                this.$emit('updateData', obj)
            }
        },
        /**
         * 0元退款
         */
        zeroRefund(obj) {
            let params = { amount: this.refundTotal, orderId: this.orderId, orderType: '4', taskItem: obj.obj }
            payDTO.createRefundTask(params).then(res => {
                if (res.code == 200) {
                    this.$message.success('操作成功，请在退款管理中查看退款进度。')
                    this.$emit('chargeRefundDialogConfirm')
                }
            })
        },

        /**
         * 选择某个处方
         */
        projectItemChange(val, item) {
            item.checked = val
            item.item && item.item.forEach(obj => {
                obj.checked = val
            })
            if (!isEmptyArray(this.ybProjectList)) {
                let obj = this.ybProjectList.find(obj => { return item.isYlcp == '1' && item.ctOrderId == obj.ctOrderId })
                if (!isNullObj(obj)) { this.changeYbChecked(val) }
            }
        },
        /**
         * 选择某个商品
         */
        itemChange(val, item) {
            item.quantity = item.doseNum
            item.item && item.item.forEach(obj => {
                obj.quantity = Number(this.$bigNumber(obj.allNum, '-', obj.refundNum))

            })
        },
        /**
         * 全选
         */
        handelAllChecked(val) {
            this.ybChecked = val
            this.notYbChecked = val
            this.changeNotYbChecked(val)
            this.changeYbChecked(val)
        },

        /**
         * 选择医保项目
         */
        changeYbChecked(val) {
            this.ybProjectList.forEach(item => {
                this.projectList.forEach(kid => {
                    if (item.orderNumber == kid.orderNumber && kid.isYlcp && kid.isYlcp == '1') {
                        this.$set(kid, 'checked', val)
                        kid.item && kid.item.forEach(kkid => { kkid.checked = val })
                    }
                })
                item.checked = val
                item.item && item.item.forEach(obj => {
                    obj.checked = val
                })
            })
        },

        /**
         * 全选非医保项目
         */
        changeNotYbChecked(val) {
            this.projectList.forEach(item => {
                if (item.projectType == '30') {
                    if (item.canChecked) {
                        item.checked = true
                        item.item && item.item.forEach(obj => {
                            obj.checked = val
                        })
                    }
                } else {
                    item.checked = val
                    item.item && item.item.forEach(obj => {
                        obj.checked = val
                    })
                    if (item.isYlcp == '1') {
                        if (!isEmptyArray(this.ybProjectList)) {
                            let obj = this.ybProjectList.find(obj => { return item.orderNumber == obj.orderNumber })
                            if (!isNullObj(obj)) {
                                this.changeYbChecked(val)
                                return
                            }
                        }
                    }
                }
                return
            })
        },
        /**
         * 付数改变
         */
        doseNumChange(currentValue, oldValue, item) {
            item.item && item.item.forEach(obj => {
                obj.quantity = Number(this.$bigNumber(obj.num, '*', currentValue))
            })
        },

        /**
        * 查询退款项目
        */
        async getRefunditem() {
            this.loading = true
            let { code, data } = await payDTO.getRefundItem({ orderId: this.orderId, orderType: 4 })
            let project = []
            if (code == 200) {
                this.loading = false;
                this.originalData = isNull(data.project) ? [] : deepClone(data.project)
                // 处理数据
                if ((!isNull(data.project) && !isEmptyArray(data.project)) || (!isNull(data.actGroups) && !isEmptyArray(data.actGroups))) {
                    data.project.forEach(item => {
                        let newItem = []
                        if (!isNull(item.item)) {
                            item.item.forEach(obj => {
                                obj.refundNum = isNull(obj.refundNum) ? 0 : obj.refundNum
                                if (!this.jgList.includes(obj.itemName) && item.projectType != '4' && obj.allNum != obj.refundNum) {
                                    item.doseNum = Number(this.$bigNumber(this.$bigNumber(obj.allNum, '-', obj.refundNum), '/', obj.num))
                                }
                                if (obj.itemName == '挂号费' || obj.itemName == '快递费' || (this.jgList.includes(obj.itemName) && item.projectType != '4') ) { obj.unit = '次' }
                                if (obj.allNum != obj.refundNum) {
                                    let residueNum = 0 //剩余可退
                                    residueNum = Number(this.$bigNumber(obj.allNum, '-', obj.refundNum))
                                    if (Utils.gt(residueNum, 0)) {
                                        newItem.push({
                                            ...obj,
                                            checked: false,
                                            residueNum,
                                            quantity: residueNum
                                        })
                                    }
                                }
                            })
                        }
                        if (!isEmptyArray(newItem)) {
                            project.push({
                                ...item,
                                checked: false,
                                doseNum: isNull(item.doseNum) || Utils.eq(item.doseNum, 0) ? 1 : Number(item.doseNum),
                                quantity: item.doseNum,
                                item: newItem
                            })
                        }
                    })

                    data.actGroups.forEach(item => {
                        let newItem = []
                        let canChecked = true
                        let hasUsed = false
                        if (!isNull(item.items)) {
                            item.items.forEach(obj => {
                                obj.refundNum = isNull(obj.refundNum) ? 0 : obj.refundNum
                                let residueNum = 0 //剩余可退
                                residueNum = Number(this.$bigNumber(obj.allNum, '-', obj.refundNum))
                                residueNum = Math.round(residueNum / (obj.onlyNum || 1) * 100) / 100
                                newItem.push({
                                    ...obj,
                                    checked: false,
                                    residueNum,
                                    quantity: residueNum
                                })
                                if (obj.useNum > 0) {
                                    hasUsed = true
                                }
                                if (obj.useNum > 0) {
                                    canChecked = false
                                }
                            })
                        }
                        const canRefundNum = newItem.reduce((acc, curr) => acc + curr.residueNum, 0)
                        if (canRefundNum === 0) {
                            canChecked = false
                        }

                        if (canRefundNum !== 0 && !isEmptyArray(newItem)) {
                            project.push({
                                ...item,
                                checked: false,
                                doseNum: isNull(item.doseNum) || Utils.eq(item.doseNum, 0) ? 1 : Number(item.doseNum),
                                quantity: item.doseNum,
                                item: newItem,
                                isMedical: '0',
                                projectType: '30',
                                canChecked: canChecked,
                                hasUsed: hasUsed
                            })
                        }
                    })

                    this.ybProjectList = project.filter(item => { return item.isMedical == '1' })
                    this.projectList = project.filter(item => { return item.isMedical == '0' })
                    this.record = isNull(data.record) ? [] : data.record
                    this.changeNotYbChecked(true)
                    this.changeYbChecked(true)
                    if(this.ybProjectList.length > 0){
                      this.comfirm()
                    }
                }
            } else {
                this.loading = false;
            }
        },

        /**
         * 处理小计金额
         * obj 商品数据
         */
        // handelPrice(item,obj) {
        //     let totalPrice = 0
        //     // 调整一品多号 新增了doseAmount（单剂药品总价） amount(药品总价) 两个字段
        //     let { quantity, allNum, price, refundAmount, refundNum,onlyNum,doseAmount,amount,num } = obj
        //     if(item.projectType == '1'){
        //       let remainTotal = this.$bigNumber(amount,'-',refundAmount) //剩余可退金额
        //       let remainNum = this.$bigNumber( item.doseNum, '-', item.quantity) //剩余剂量
        //       let remainPrice = this.$bigNumber(doseAmount, '*', remainNum,2) //剩余剂量总价
        //       totalPrice = this.$bigNumber(remainTotal, '-', remainPrice)
        //     }else{
        //       if (Utils.eq(this.$bigNumber(quantity, '+', refundNum), allNum)) {
        //       // 全退
        //       let total = this.$bigNumber(allNum, '*', price, 2) //总支付金额
        //       totalPrice = this.$bigNumber(total, '-', refundAmount)
        //       } else {
        //         let temp = this.$bigNumber(quantity,'*',isNull(onlyNum) ? 1 :onlyNum)
        //         totalPrice = this.$bigNumber(temp, '*', price, 2)
        //       }
        //     }
        //     return totalPrice;
        // },
        handelPrice(item,obj) {
            let totalPrice = 0
            let { quantity, allNum, price, residueNum, refundAmount, refundNum,onlyNum } = obj
            // 判断当前退款是否全退，如果是全退 小计等于 总价-已退款金额，否则等于 数量*单价
            // 当前输入数量+已退款数量 = 总购买数量？全退：不是全退
            if (Utils.eq(this.$bigNumber(quantity, '+', refundNum), allNum)) {
                // 全退
                let total = this.$bigNumber(allNum, '*', price, 2) //总支付金额
                totalPrice = this.$bigNumber(total, '-', refundAmount)
            } else {
                let temp = this.$bigNumber(quantity,'*',isNull(onlyNum) ? 1 :onlyNum)
                totalPrice = this.$bigNumber(temp, '*', price, 2)
            }
            return totalPrice;
        },
        // handelPrice(item,obj) {
        //     let totalPrice = 0
        //     // 调整一品多号 新增了doseAmount（单剂药品总价） amount(药品总价) 两个字段
        //     let { quantity, allNum, price, residueNum, refundAmount, refundNum,onlyNum,doseAmount,amount } = obj
        //     // 判断当前退款是否全退，如果是全退 小计等于 总价-已退款金额，否则等于 药品单剂总价 * 剂数
        //     // 当前输入数量+已退款数量 = 总购买数量？全退：不是全退
        //     if (Utils.eq(this.$bigNumber(quantity, '+', refundNum), allNum)) {
        //         // 全退
        //         // let total = this.$bigNumber(doseAmount, '*', item.quantity, 2) //总支付金额
        //         totalPrice = this.$bigNumber(amount, '-', refundAmount)
        //     } else {
        //         let temp = this.$bigNumber(quantity,'*',isNull(onlyNum) ? 1 :onlyNum)
        //         totalPrice = this.$bigNumber(temp, '*', price, 2)
        //         // totalPrice = this.$bigNumber(doseAmount, '*', (item.projectType == '1' ? item.quantity : this.$bigNumber(quantity,'*',isNull(onlyNum) ? 1 :onlyNum)), 2)
        //     }
        //     return totalPrice;
        // },

        /**
        * 关闭
        */
        dialogVisible(name) {
            this.$emit("close", name);
        },

        /**
         * 计算退款总价
         */
        computedTotal() {
            let total = 0
            this.ybProjectList.forEach(item => {
                item.item && item.item.forEach(obj => {
                    if (this.jgList.includes(obj.itemName) && item.projectType != '4') {
                        obj.totalPrice =obj.price
                    } else {
                        obj.totalPrice = this.handelPrice(item,obj) //小计=付数*原本购买数量*价格
                    }
                    if (obj.checked) total = this.$bigNumber(obj.totalPrice, '+', total)
                })
            })
            this.projectList.forEach(item => {
                if (item.projectType == '30') {
                    item.item && item.item.forEach(obj => {
                        if (obj.checked) total = this.$bigNumber(obj.amount, '+', total)
                    })
                } else {
                    item.item && item.item.forEach(obj => {
                        if (this.jgList.includes(obj.itemName) && item.projectType != '4') {
                            obj.totalPrice =  obj.price
                        } else {
                            obj.totalPrice = this.handelPrice(item,obj) //小计=付数*原本购买数量*价格
                        }
                        if (obj.checked) total = this.$bigNumber(obj.totalPrice, '+', total)
                    })
                }
                
            })
            this.refundTotal = total
        },
        /**
         * 判断是否全选
         */
        judeStatus() {
            this.ybProjectList.forEach(item => {
                item.checked = item.item && item.item.every(obj => { return obj.checked })
            })
            this.projectList.forEach(item => {
                item.checked = item.item && item.item.every(obj => { return obj.checked })
            })
            this.ybChecked = this.ybProjectList.every(item => { return item.checked })
            this.notYbChecked = this.projectList.every(item => { return item.checked })
            this.allChecked = this.ybChecked && this.notYbChecked
        },
        //判断当前订单是否可退
        judgeIsRefund(){
            return new Promise(async (resolve, reject) => {
                let {code,data} =await formulaDTO.getFormulatingPrescription({orderId:this.orderId})
                if(code==200){
                    resolve(data.existFormulatingPrescription || false)
                }else{
                    resolve(false)
                }
            })
        },
        async copyExecuteId(physioExecuteIds) {
            const text = physioExecuteIds.join(',')
            try {
                await navigator.clipboard.writeText(text);
                this.$message.success('复制成功')
            } catch (err) {
                console.log(err)
                this.$message.error('复制失败')
            }
        }
    },
}
</script>
<style lang="less" scoped>
.dialog-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0 24px;
    border-bottom: 1px solid #EBEAEE;
    color: #1F2329;
    font-size: 16px;
    font-weight: 500;

    .close-icon {
        width: 16px;
        height: 16px;
        ;
    }
}

.refundItemContent {
  .content_tips{
    line-height:36px;
    background: #E8F4FF;
    border-radius: 4px 4px 4px 4px;
    color:#000;
    font-size:13px;
    padding:0 16px;
    margin-bottom: 20px;
  }
    .disabled {
        background: #f8f9f9;
        cursor: not-allowed;
    }

    .table {
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #D3D3D5;
        margin-top: 14px;
    }

    .table-header {
        width: 100%;
        display: flex;
        height: 40px;
        align-items: center;
        background: #F0F1F3;
        border-bottom: 1px solid #D3D3D5;
    }

    .table-row {
        display: flex;
        height: 39px;
        border-bottom: 1px dashed #D3D3D5;

        &:last-child {
            border-bottom: none;
        }

        .checkbox-warp {
            width: 32px;
            line-height: 40px;
            text-align: center;
            flex-shrink: 0;
            border-right: 1px dashed #D3D3D5;
        }

        .row-content {
            flex: 1;
            padding-left: 8px;
            padding-right: 8px;
            line-height: 40px;
            border-right: 1px dashed #D3D3D5;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .number-warp {
            width: 86px;
            line-height: 40px;
            border-right: 1px dashed #D3D3D5;
            display: flex;
            justify-content: center;

            /deep/.el-input-number__decrease {
                display: none;
            }

            /deep/.el-input-number__increase {
                display: none;
            }

            /deep/.el-input__inner {
                width: 86px;
                font-weight: normal;
                box-sizing: border-box;
                text-align: center;
                height: 39px;
                border-radius: 0;
                border: none;
                color: #1F2329 !important;
                padding: 0;
            }
        }

        .unit-warp {
            width: 38px;
            line-height: 40px;
            border-right: 1px dashed #D3D3D5;
            text-align: center;
            background: #f8f9f9;
            cursor: not-allowed;
        }

        .price-warp {
            width: 124px;
            line-height: 40px;
            border-right: 1px dashed #D3D3D5;
            text-align: center;
            background: #f8f9f9;
            cursor: not-allowed;
        }
    }

}

.phy_executed {
    line-height: 20px;
    font-size: 14px;
    color: #667182;
}

.phy_executed_copy {
    margin: 0 0 0 4px;
    color: #1890FF;
    cursor: pointer;
    user-select: none;
}

.activity-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.activity-count {
    margin: 0 0 0 14px;
    line-height: 20px;
    font-size: 13px;
    color: #667182;
}

.activity-tips {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 0 12px;
}

.activity-tips-icon {
    font-size: 14px;
    color: #1890FF;
}

.activity-tips-text {
    margin: 0 0 0 4px;
    font-size: 13px;
    color: #667182;
}

.footer {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    border-top: 1px solid #EBEAEE;
}
</style>